import Vue from 'vue'
import Router from 'vue-router'

import * as Util from '@/util/util'

Vue.use(Router)

const route = new Router({
  routes: [
    {
      path: '/',
      redirect: '/product'
    },
    {
      path: '/login',
      name: 'Login',
      component: resolve => require(['@/view/insurance/Login'], resolve),
      meta: {title: '保险服务'}
    },
    {
      path: '/claim',
      name: 'claim',
      redirect: "/claim/explain",
      component: resolve => require(['@/view/insurance/Home'], resolve),
      meta: {title: '保险服务'},
      children:[{
				path: "explain",
        name: "/claim/explain",
        meta: {title: '保险服务',hType:'1',tabi:'3'},
				component:resolve => require(['@/view/insurance/1an/ClaimExplain'], resolve)
      }]
    },
    {
      path: '/product',
      name: 'product',
      redirect: "/product/list",
      component: resolve => require(['@/view/insurance/Home'], resolve),
      meta: {title: '保险服务'},
      children:[{
				path: "list",
        name: "/product/list",
        meta: {title: '保险服务',hType:'1',tabi:'1'},
				component:resolve => require(['@/view/insurance/1an/ProductList'], resolve)
      },{
        path: "household",
        name: "/product/household",
        meta: {title: '保险服务',hTitle: '户用光伏保险',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/Household'], resolve)
      },{
        path: "householdstep1",
        name: "/product/householdstep1",
        meta: {title: '保险服务',hTitle: '在线投保',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/HouseholdStep1'], resolve)
      },{
        path: "householdstep2",
        name: "/product/householdstep2",
        meta: {title: '保险服务',hTitle: '在线投保',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/HouseholdStep2'], resolve)
      },{
        path: "company",
        name: "/product/company",
        meta: {title: '保险服务',hTitle: '企业光伏保险（100万以下）',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/Company'], resolve)
      },{
        path: "companystep1",
        name: "/product/companystep1",
        meta: {title: '保险服务',hTitle: '在线投保',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/CompanyStep1'], resolve)
      },{
        path: "companystep2",
        name: "/product/companystep2",
        meta: {title: '保险服务',hTitle: '在线投保',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/CompanyStep2'], resolve)
      },{
        path: "highprice",
        name: "/product/highprice",
        meta: {title: '保险服务',hTitle: '企业光伏保险（100万以上）',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/HighPrice'], resolve)
      },{
        path: "highpricestep1",
        name: "/product/highpricestep1",
        meta: {title: '保险服务',hTitle: '在线投保',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/HighPriceStep1'], resolve)
      },{
        path: "highpricestep2",
        name: "/product/highpricestep2",
        meta: {title: '保险服务',hTitle: '在线投保',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/HighPriceStep2'], resolve)
      },{
        path: "prepay",
        name: "/product/prepay",
        meta: {title: '保险服务',hTitle: '在线投保',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/PrePay'], resolve)
      },{
        path: "paysuccess",
        name: "/product/paysuccess",
        meta: {title: '保险服务',hTitle: '在线投保',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/PaySuccess'], resolve)
      }]
    },
    {
      path: '/order',
      name: 'order',
      redirect: "/order/list",
      component: resolve => require(['@/view/insurance/Home'], resolve),
      meta: {title: '保险服务'},
      children:[{
				path: "list",
        name: "/order/list",
        meta: {title: '保险服务',hType:'1',tabi:'2'},
				component:resolve => require(['@/view/insurance/1an/OrderList'], resolve)
      },{
        path: "detail",
        name: "/order/detail",
        meta: {title: '保险服务',hTitle: '在线投保',hType:'2'},
				component:resolve => require(['@/view/insurance/1an/OrderDetail'], resolve)
      }]
    },
    { path: '*', redirect: '/' }
  ]
})

route.beforeEach((to, from, next) => {
  //百度统计
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
  //读取渠道信息并保存
  if(Util.getPathParam('channel')){
    sessionStorage.setItem('e10adc3949ba59abbe56e057f20f883e',Util.getPathParam('channel'))// solar-insurance-channel
  }

  if(location.href.indexOf('?1anInsuranceCallback')>-1){
    location.replace(location.origin + location.pathname + "#/product/paysuccess");
  } else if(to.path=='/product/paysuccess'){
    next();
  } else if(Util.getPathParam('userId')){
      let platformType = Util.getPathParam('platformType');
      Util.updateUserInfo({
          userId:Util.getPathParam('userId'),
          uid:Util.getPathParam('userId'),
          platformType:platformType,
          companyId:Util.getPathParam('companyId'),
          fromApp:Util.getPathParam('fromApp'),
          hideTitle:(platformType == '10' || platformType == '11')?true:false
      });
      Util.updateSessionUserInfo({
          userId:Util.getPathParam('userId'),
          uid:Util.getPathParam('userId'),
          platformType:platformType,
          companyId:Util.getPathParam('companyId'),
          fromApp:Util.getPathParam('fromApp'),
          hideTitle:(platformType == '10' || platformType == '11')?true:false
      });
      if (to.meta.title) {
        document.title = to.meta.title
      }
      next();
  } else if(to.path !== '/login' && !Util.getSessionUserInfo().uid){
    next('/login')
  } else {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  }
  
});

export default route



// WEBPACK FOOTER //
// ./src/router/insurance/1an.js